module.exports = __webpack_public_path__ + "img/icon-title-page.9fcbc0e6.svg";